/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Company-templateEmployeesGrid .k-grid-content{max-height:calc(37px * 8)}@media (min-width:1440px){.Company-templateEmployeesGrid .k-grid-content{max-height:calc(37px * 12)}}@media (min-width:1900px){.Company-templateEmployeesGrid .k-grid-content{height:44vh}}.Company-templateEmployeesGrid .k-grid-content tbody tr{cursor:pointer}"];
export { styles as styles };
